<template>
  <el-row class="container">
    <el-col :span="24" class="header">
      <el-col :span="10" class="logo" :class="collapsed ? 'logo-collapse-width' : 'logo-width'">
        <a href="http://jazpan.com" v-if="!collapsed" class="logoA">夹子盘</a>
        <a href="http://jazpan.com" v-if="collapsed" class="logoA">夹</a>
      </el-col>
      <el-col :span="10">
        <div class="tools" @click.prevent="collapse">
          <i class="fa fa-align-justify"></i>
        </div>
      </el-col>
      <el-col :span="4" class="userinfo">
        <el-dropdown trigger="hover">
          <span class="el-dropdown-link userinfo-inner">
            <img :src="getUserInfo.avat || '//static.jazpan.com/img/user.png'" />
            {{ getUserInfo.nick }}</span>
          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item>我的消息</el-dropdown-item> -->
            <el-dropdown-item @click.native="$refs.passEditor.show()">修改密码</el-dropdown-item>
            <el-dropdown-item divided @click.native="logoutFun">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    </el-col>
    <el-col :span="24" class="main">
      <aside :class="collapsed ? 'menu-collapsed' : 'menu-expanded'">
        <!--导航菜单-->
        <div v-if="!collapsed" style="height: 100%;display: flex;flex-direction: column;">
          <el-menu :default-active="$route.path" class="el-menu-vertical-demo" @open="handleopen" @close="handleclose"
            @select="handleselect" unique-opened router>
            <template v-for="(item, index) in $router.options.routes">
              <div :key="'m1:' + index" v-if="!item.hidden">
                <el-submenu :index="index + ''" v-if="!item.leaf">
                  <template slot="title"><i :class="item.iconCls"></i>{{ item.name }}</template>
                  <template v-for="child in item.children">
                    <el-menu-item :index="child.path" :key="child.path" v-if="!child.hidden">{{ child.name
                    }}</el-menu-item>
                  </template>
                </el-submenu>
                <el-menu-item v-if="item.leaf && item.children.length > 0" :index="item.children[0].path"><i
                    :class="item.iconCls"></i>{{ item.children[0].name }}</el-menu-item>
              </div>
            </template>
          </el-menu>
          <div class="prograssDiv">
            <!-- <div class="texts">我的空间</div> -->
            <div class="texts">{{ getFlSize(spaceInfo.useSize) }} / {{ spaceInfo.spaceSize }} GB <i class="el-icon-warning-outline"
                style="color:#f60;cursor: pointer;" @click="$refs.chongVipDlg.show()" /></div>
            <div><el-progress :show-text="false" :percentage="spaceInfo.percent" :status="spaceInfo.status"></el-progress></div>
          </div>
        </div>
        <!--导航菜单-折叠后-->
        <ul class="el-menu el-menu-vertical-demo collapsed" v-if="collapsed" ref="menuCollapsed">
          <template v-for="(item, index) in $router.options.routes">
            <li :key="'m2:' + index" v-if="!item.hidden" class="el-submenu item">
              <template v-if="!item.leaf">
                <div class="el-submenu__title" style="padding-left: 20px;" @mouseover="showMenu(index, true)"
                  @mouseout="showMenu(index, false)"><i :class="item.iconCls"></i></div>
                <ul class="el-menu submenu" :class="'submenu-hook-' + index" @mouseover="showMenu(index, true)"
                  @mouseout="showMenu(index, false)">
                  <template v-for="child in item.children">
                    <li v-if="!child.hidden" :key="child.path" class="el-menu-item" style="padding-left: 40px;"
                      :class="$route.path == child.path ? 'is-active' : ''" @click="$router.push(child.path)">{{
                        child.name }}
                    </li>
                  </template>
                </ul>
              </template>
              <template v-else>
            <li class="el-submenu">
              <div class="el-submenu__title el-menu-item"
                style="padding-left: 20px;height: 56px;line-height: 56px;padding: 0 20px;"
                :class="$route.path == item.children[0].path ? 'is-active' : ''"
                @click="$router.push(item.children[0].path)">
                <i :class="item.iconCls"></i>
              </div>
            </li>
          </template>
          </li>
          </template>
        </ul>
      </aside>
      <section class="content-container">
        <div class="grid-content bg-purple-light">
          <el-col :span="24" class="breadcrumb-container">
            <strong class="title">{{ $route.name }}</strong>
            <el-breadcrumb separator="/" class="breadcrumb-inner">
              <el-breadcrumb-item v-for="item in $route.matched" :key="item.path">
                {{ item.name }}
              </el-breadcrumb-item>
            </el-breadcrumb>
          </el-col>
          <el-col :span="24" class="content-wrapper">
            <transition name="fade" mode="out-in">
              <router-view></router-view>
            </transition>
          </el-col>
        </div>
      </section>
      <PassForm ref="passEditor" />
      <ChongVip ref="chongVipDlg" @submitOK="getSpaceInfo()" />
    </el-col>
  </el-row>
</template>

<script>
import util from '@/common/js/util'
import { mapGetters } from 'vuex'
import { mapActions } from 'vuex'
import PassForm from './ruis/user/PassForm'
import ChongVip from '@/components/ChongVip'

export default {
  components: { PassForm, ChongVip },
  data () {
    return {
      collapsed: false,
      spaceInfo: {},
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
      }
    }
  },
  computed: {
    // 使用对象展开运算符将 getters 混入 computed 对象中
    ...mapGetters([
      'getUserInfo'
    ])
  },
  methods: {
    getFlSize: util.getFlSize,
    onSubmit () {
      console.log('submit!');
    },
    handleopen () {
      //console.log('handleopen');
    },
    handleclose () {
      //console.log('handleclose');
    },
    handleselect: function (a, b) {
    },
    //退出登录
    logoutFun: function () {
      var that = this;
      this.$confirm('确认退出吗?', '提示', {
        //type: 'warning'
      }).then(() => {
        this.$post('/lg/logout').then(res => {
          // console.log('uinfo:',res);
          this.$message('退出成功');
          //window.top.location.reload();
          this.$router.push('/login');
        }).catch(err => {
          this.$message({
            message: err.response ? err.response.data || '服务器错误' : '网络错误',
            type: 'error'
          });
        });
      }).catch(() => {

      });


    },
    //折叠导航栏
    collapse: function () {
      this.collapsed = !this.collapsed;
    },
    showMenu (i, status) {
      this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-' + i)[0].style.display = status ? 'block' : 'none';
    }, getSpaceInfo () {
      this.$post('/user/space/info', {}).then(res => {
        this.spaceInfo=res.data;
      }).catch(err => {
        this.$message({
          message: err.response ? err.response.data || '服务器错误' : '网络错误',
          type: 'error'
        });
      });
    }
  },
  mounted () {
    var user = sessionStorage.getItem('user');
    if (user) {
      user = JSON.parse(user);
      this.sysUserName = user.name || '';
      this.sysUserAvatar = user.avatar || '';
    }

    this.getSpaceInfo();
  }
}

</script>

<style scoped lang="scss">
@import "~scss_vars";

.container {
  position: absolute;
  top: 0px;
  bottom: 0px;
  width: 100%;

  .header {
    height: 60px;
    line-height: 60px;
    background: #f0f6fa;
    color: #000;

    .logoA {
      color: #db8585;
      text-decoration: none;
      font-weight: bold;
    }

    .userinfo {
      text-align: right;
      padding-right: 35px;
      float: right;

      .userinfo-inner {
        cursor: pointer;
        color: #000;
        font-weight: bold;

        img {
          width: 40px;
          height: 40px;
          border-radius: 20px;
          margin: 10px 0px 10px 10px;
          float: right;
        }
      }
    }

    .logo {
      //width:230px;
      height: 60px;
      font-size: 22px;
      padding-left: 20px;
      padding-right: 20px;
      border-color: rgba(238, 241, 146, 0.3);
      border-right-width: 1px;
      border-right-style: solid;

      img {
        width: 40px;
        float: left;
        margin: 10px 10px 10px 18px;
      }

      .txt {
        color: #fff;
      }
    }

    .logo-width {
      width: 230px;
    }

    .logo-collapse-width {
      width: 60px;
    }

    .tools {
      padding: 0px 23px;
      width: 14px;
      height: 60px;
      line-height: 60px;
      cursor: pointer;
    }
  }

  .main {
    display: flex;
    // background: #324057;
    position: absolute;
    top: 60px;
    bottom: 0px;
    overflow: hidden;

    .prograssDiv {
      border-right: solid 1px #e6e6e6;

      .texts {
        text-align: center;
        height: 25px;
      }
    }

    aside {
      flex: 0 0 230px;
      width: 230px;

      // position: absolute;
      // top: 0px;
      // bottom: 0px;
      .el-menu {
        height: 100%;
      }

      .collapsed {
        width: 60px;

        .item {
          position: relative;
        }

        .submenu {
          position: absolute;
          top: 0px;
          left: 60px;
          z-index: 99999;
          height: auto;
          display: none;
        }
      }
    }

    .menu-collapsed {
      flex: 0 0 60px;
      width: 60px;
    }

    .menu-expanded {
      flex: 0 0 230px;
      width: 230px;
    }

    .content-container {
      // background: #f1f2f7;
      flex: 1;
      // position: absolute;
      // right: 0px;
      // top: 0px;
      // bottom: 0px;
      // left: 230px;
      overflow-y: scroll;
      padding: 20px;

      .breadcrumb-container {

        //margin-bottom: 15px;
        .title {
          width: 200px;
          float: left;
          color: #475669;
        }

        .breadcrumb-inner {
          float: right;
        }
      }

      .content-wrapper {
        background-color: #fff;
        box-sizing: border-box;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// Home.vue?4e053c20